import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.043 1.523a4.7 4.7 0 0 1 2.145-.522l-1.04 1.5a3.33 3.33 0 0 0-2.29 3.307L3.821 7.302a1 1 0 0 1-.038-.09 4.67 4.67 0 0 1 2.259-5.689",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.595 14.638 3.822 7.302l1.035-1.494c.008.174.03.355.064.525h6.533A3.336 3.336 0 0 0 9.72 2.708 3.33 3.33 0 0 0 7.149 2.5L8.188 1a4.667 4.667 0 0 1 4.4 6.221 1 1 0 0 1-.042.095l-3.765 7.321a.667.667 0 0 1-1.186 0M5.508 7.667l2.68 5.209 2.679-5.21z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })